import { lazy, useState } from 'react';

import { importReactConfetti } from '@perpay-web/fintech/utils/imports/importReactConfetti';
import { getClassName } from '@perpay-web/utils/domUtils';

import stylesConstants from '@perpay-web/design/src/styles/constants.scss';

const LazyConfettiComponent = lazy(importReactConfetti);

const confettiColors = [
    stylesConstants['accessible-blue'],
    stylesConstants['dots-blue'],
    stylesConstants['blue-12'],
    stylesConstants['perpay-green'],
    stylesConstants['alert-green-border'],
];

const ReactConfetti = ({
    height = window.innerHeight,
    width = window.innerWidth,
    className = '',
}) => {
    // Remove the <canvas> from the DOM after ConfettiComplete as it affects other elements when resizing
    const [isConfettiCanvasVisible, setConfettiCanvasVisible] = useState(true);

    return isConfettiCanvasVisible && !window.STORYBOOK ? (
        <LazyConfettiComponent
            onConfettiComplete={() => setConfettiCanvasVisible(false)}
            recycle={false}
            colors={confettiColors}
            height={height}
            width={width}
            className={getClassName(className)}
        />
    ) : null;
};

export default ReactConfetti;
